import { useEligibilityAccess } from '@features/billing/hooks/useEligibilityAccess';
import { useBillingSettingsAccess } from '@features/billing-readiness/hooks/useBillingSettingsAccess';
import { useJotRxSetupState } from '@features/eprescriptions';
import { useOrgReviewCount } from '@features/practice-data-import';
import { useCan, useSubjectLanguageVariants } from '@features/user';
import { FeatureGates, useFeatureGate } from '@services/statsig';
import { hasRole, ROLES } from '@utils/roleUtils';

import { practiceSettingsItems } from '../components/PracticeSettings/practiceSettingsItems';
import { useOrganizationAccess } from '../store';

export function usePracticeSettingsItems(memberCount = 0) {
  const { userState } = useOrganizationAccess();
  const organization = useCan('manage_organization');
  const billing = useCan('manage_billing');
  const eligibility = useCan('manage_eligibility');
  const compensation = useCan('configure_compensation');
  const { hasAccess: eligibilityEnabled } = useEligibilityAccess();
  const subscription = useCan('manage_subscription');
  const appointmentTypes = useCan('manage_appointment_types');
  const appointmentLabels = useCan('manage_appointment_labels');
  const calendar = useCan('manage_org_calendar');
  const templates = useCan('manage_templates');
  const schedulingEnabled = useFeatureGate(FeatureGates.PATIENT_SELF_SCHEDULING);
  const appointmentTypeCatalog = useFeatureGate(FeatureGates.PRACTICE_TYPE_CATALOG);
  const templatesEnabled = useFeatureGate(FeatureGates.PRACTICE_TEMPLATE_CATALOG);
  const requirements = useFeatureGate(FeatureGates.PATIENT_REQUIREMENTS);
  const { hasAccess: billingEnabled } = useBillingSettingsAccess();
  const { singularCap, plural } = useSubjectLanguageVariants();
  const { isJotRxEnabled } = useJotRxSetupState();
  const importCount = useOrgReviewCount();
  return practiceSettingsItems({
    organization,
    patientManagementPreview: requirements,
    practiceAdmin: hasRole(userState?.group_user_roles, ROLES.PRACTICE_ADMINISTRATOR),
    members: billing,
    subscription,
    billing: billing && billingEnabled,
    billingIdentities:
      (billing && billingEnabled) || ((billing || eligibility) && eligibilityEnabled),
    compensation,
    appointmentTypes,
    appointmentTypeCatalog,
    appointmentLabels,
    selfScheduling: calendar && schedulingEnabled,
    templates: templates && templatesEnabled,
    requirements,
    prescriptions: isJotRxEnabled,
    importCount,
    memberCount,
    subjectLabel: singularCap,
    subjectPlural: plural,
  });
}
